"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Products = void 0;
var _contexts = require("../../contexts");
var _Product = require("../Product");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Products = () => {
  const {
    products = []
  } = (0, _contexts.useShadePicker)();
  if (products.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    children: products.map((product, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Product.Product, {
      index: index,
      ...product
    }, product.code))
  });
};
exports.Products = Products;
//# sourceMappingURL=Products.js.map